import { Login } from './login/Login'
import { Signup } from './signup/Signup'
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './security/AuthContext';
import { ProtectedRoute } from './security/ProtectedRoute';
import { Shell } from './shell/Shell';
import MessageEditor from './components/MessageEditor'
import { MessageCreate } from './pages/messages/MessageCreate';
import { MessageEdit } from './pages/messages/MessageEdit';
import { ThreadsList } from './pages/messages/list/ThreadsList'
import { UserEdit } from './pages/users/UserEdit'
import ProfilePage from './pages/Profile';
import { Users } from './pages/users/Users';
import { UserCreate } from './pages/users/UserCreate';
import ThemeToggle from './components/ThemeToggle';
import { About } from './pages/About';
import { Contact } from './pages/Contact';
import { Terms } from './pages/Terms';
import { Privacy } from './pages/Privacy';
import { ForgotPassword } from './login/ForgotPassword';
import { Groups } from './pages/Groups/Groups';
import { EditGroups } from './pages/Groups/GroupsEdit';
import { CreateGroups } from './pages/Groups/GroupsCreate';
import { ThemeProvider } from './theme/ThemeContext';
import { NotificationProvider } from './components/Notifications';
import { MessageView } from './pages/messages/MessageView';
import { Config } from './pages/Config';
import { Test } from './pages/Test';
import { DeletedThreads } from './pages/messages/DeletedMessage';
import { Unauthorized } from './pages/Unauthorized';
import { Participants } from './pages/messages/participants/Participants';



export default function App() {
  return (
    <NotificationProvider>
      <AuthProvider>
        <ThemeProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/login" element={<Login />} />
              <Route path="/signup" element={<Signup />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route element={<ProtectedRoute />}>
                <Route element={<Shell />}>
                  <Route path="/" element={<ThreadsList />} />
                  <Route path="/Editor" element={<MessageEditor />} />
                  <Route path="/Users" element={<Users />} />
                  <Route path="/users/create" element={<UserCreate />} />
                  <Route path="/users/edit/:id" element={<UserEdit />} />
                  <Route path="/messages" element={<ThreadsList />} />
                  <Route path="/messages/create" element={<MessageCreate />} />
                  <Route path="/messages/edit/:id" element={<MessageEdit />} />
                  <Route path="/messages/participants/:id" element={<Participants />} />
                  <Route path="/messages/:id" element={<MessageView />} />
                  <Route path="/DeletedThreads" element={<DeletedThreads/>} />
                  <Route path="/ThemeToggle" element={<ThemeToggle />} />
                  <Route path="/Profile" element={<ProfilePage />} />
                  <Route path="/About" element={<About />} />
                  <Route path="/Contact" element={<Contact />} />
                  <Route path="/Terms" element={<Terms />} />
                  <Route path="/Privacy" element={<Privacy />} />
                  <Route path="/config" element={<Config />} />
                  <Route path="/Groups" element={<Groups />} />
                  <Route path="/groups/edit/:id" element={<EditGroups />} />
                  <Route path="/groups/edit/:id" element={<EditGroups/>} />
                  <Route path="/groups/create" element={<CreateGroups />} />
                  <Route path="/test" element={<Test />} />
                  <Route path="/unauthorized" element={<Unauthorized />} />
                </Route>
              </Route>
            </Routes>
          </BrowserRouter>
        </ThemeProvider>
      </AuthProvider>
    </NotificationProvider>
  );
}